import { APP_STORE_URL, PLAY_STORE_URL } from "@/lib/appConfig"

interface StoreButtonsProps {
  /** Extra classes on the wrapper div */
  className?: string
  /** Size variant: sm = compact (for sidebar), md = default */
  size?: "sm" | "md"
}

/**
 * Renders App Store and/or Google Play download badges (desktop only).
 * Returns null if both VITE_APP_STORE_URL and VITE_PLAY_STORE_URL are empty.
 */
export function StoreButtons({ className = "", size = "md" }: StoreButtonsProps) {
  if (!APP_STORE_URL && !PLAY_STORE_URL) return null

  const imgClass = size === "sm" ? "h-7 w-auto" : "h-9 w-auto"

  return (
    <div className={`hidden md:flex items-center gap-2 ${className}`}>
      {APP_STORE_URL && (
        <a href={APP_STORE_URL} target="_blank" rel="noreferrer" className="hover:opacity-80 transition-opacity">
          <img src="/download-from-app-store.svg" alt="Download on the App Store" className={imgClass} />
        </a>
      )}
      {PLAY_STORE_URL && (
        <a href={PLAY_STORE_URL} target="_blank" rel="noreferrer" className="hover:opacity-80 transition-opacity">
          <img src="/download-from-play.svg" alt="Get it on Google Play" className={imgClass} />
        </a>
      )}
    </div>
  )
}
